export default __webpack_public_path__ + "static/media/laptop.d4e5a6ae.png";